import { createAsyncAction } from "./utils";

export const getDeleteBuild = createAsyncAction("CARDS/GET_DELETE");
